import { ApiError } from '@/shared/api/errors';

// Plain names for the fields the calls endpoints validate.
const FIELD_LABELS: Record<string, string> = {
  name: 'Use-case name',
  greeting: 'Opening line',
  notifyEmails: 'Summary email recipients',
  transferNumber: 'Transfer number',
  doctorLastName: 'On-call doctor',
  areaCode: 'Area code',
  languages: 'Response languages',
  valueTable: 'Estimated value',
  alertPhones: 'Alert phone numbers',
  callbackPromise: 'Callback promise',
  formsLink: 'Forms link',
  saveLine: 'Save line',
  cancellationPolicy: 'Cancellation policy',
  insuranceList: 'Insurance list',
  procedures: 'Procedures',
  offerName: 'Offer name',
  offerPrice: 'Offer price',
  offerTerms: 'Offer terms',
  offerExpiry: 'Offer expiry',
  targetService: 'Target service',
  campaignId: 'Linked campaign',
  startDate: 'First closed day',
  endDate: 'Last closed day',
  message: 'Closure message',
  fallbackNumber: 'Fallback number',
};

function labelFor(path: string): string {
  // e.g. "notifyEmails.2" or "configJson.valueTable.Invisalign"
  const parts = path.split('.').filter((p) => p !== 'configJson' && !/^\d+$/.test(p));
  const known = parts.find((p) => FIELD_LABELS[p]);
  if (!known) return parts.join(' ') || 'A field';
  const detail = parts[parts.indexOf(known) + 1];
  return detail ? `${FIELD_LABELS[known]} (${detail})` : FIELD_LABELS[known];
}

// The backend's 422 carries per-field reasons that the generic message
// ("Validation failed") throws away — surface them so the user knows what to fix.
export function describeCallsError(err: Error, fallback: string): string {
  const fieldErrors =
    err instanceof ApiError
      ? ((err.data?.error as { errors?: Record<string, string[]> } | undefined)?.errors ?? null)
      : null;
  if (fieldErrors && Object.keys(fieldErrors).length > 0) {
    const lines = Object.entries(fieldErrors).map(
      ([path, msgs]) => `${labelFor(path)}: ${msgs[0] ?? 'invalid'}`,
    );
    return `Please fix: ${lines.join('; ')}`;
  }
  return err.message || fallback;
}
